<template>
    <div class="operation-container">
        <div class="operation-box">
            <ul class="operation" id="operationBox">
                <li class="operation-item" v-for="(item, i) in operationList" :key="i" :class="{status:!item.status}"
                    @click="operationCheck(item.status, item.className, item.name)">
                    <span :class="item.className + ' iconbg'">
                        <i :class="'icon iconfont ' + item.icon"></i>
                    </span>
                    <span class="item-name">{{item.name}}</span>
                </li>
            </ul>
            <!-- <div class="search-box">
                <input type="text" placeholder="搜索" v-model="searchVal">
                <i class="icon iconfont icon-search"></i>
            </div> -->
        </div>
        <div class="operation-select">
            操作
        </div>
    </div>
</template>
<script>
export default {
    name: 'OperationComponent',
    props: ['options'],
    data() {
        return {
            operationList: [],
            defaultStatus: [],
            searchVal: ''
        }
    },
    created() {
        this.getOperationData();
        this.Bus.$on('updataOperationStatus', res => {
            this.changeStatus(res);
        });
    },
    mounted() {},
    methods: {
        getOperationData() {
            this.operationList = [];
            this.$axios.get('static/json/operation.json').then(res => {
                let data = res.data;
                for(let i = 0; i < this.options.length; i++) {
                    let key = this.options[i], item = data[key];
                    if(item) {
                        item['className'] = key;
                        this.operationList.push(item);
                        this.defaultStatus.push(item.status);
                    }
                }
            });
        },
        operationCheck(status, type, name) {
            if(status) {
                this.$emit('operationCheck', type, name);
            }
        },
        changeStatus(res) {
            if(typeof res == 'boolean' && !res) {
                // res===false, 操作栏全部变为禁用状态
                for(let i = 0; i < this.operationList.length; i++) {
                    this.operationList[i].status = false;
                }
            }
            if(typeof res == 'object') {
                if(res.length > 0) {
                    let key = null;
                    for(let i = 0; i < this.operationList.length; i++) {
                        key = this.operationList[i].className;
                        if(res.indexOf(key) > -1) {
                            this.operationList[i].status = true;
                        } else {
                            this.operationList[i].status = false;
                        }
                    }
                } else {
                    // 恢复默认状态
                    for(let i = 0; i < this.operationList.length; i++) {
                        this.operationList[i].status = this.defaultStatus[i];
                    }
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import './OperationComponent.scss';
</style>


// WEBPACK FOOTER //
// src/components/common/operation/OperationComponent.vue